import { render, staticRenderFns } from "./AcceptNewAccount.vue?vue&type=template&id=1252a749&scoped=true&lang=pug"
import script from "./AcceptNewAccount.vue?vue&type=script&lang=js"
export * from "./AcceptNewAccount.vue?vue&type=script&lang=js"
import style0 from "./AcceptNewAccount.vue?vue&type=style&index=0&id=1252a749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252a749",
  null
  
)

export default component.exports